<template lang="pug">
  div
    el-col.hidden-sm-and-down(:span="8" style="font-size: 30px; font-weight: bolder; text-align: center")
      | NiceCourseToU
    el-col.hidden-md-and-up(:span="8" style="font-size: 16px; font-weight: bolder; text-align: center")
      | NiceCourseToU
</template>
<script>
export default {
  name: 'logo-title'
}
</script>
